/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { ComponentType } from '@angular/cdk/portal';
import {
  booleanAttribute,
  Component,
  EventEmitter,
  inject,
  Input,
  output,
  Output,
  OutputEmitterRef,
  ViewContainerRef,
} from '@angular/core';
import { ButtonComponent, ButtonVariants } from '@ods/system';
import { DIALOG_COMPONENT } from '../ozgcloud-dialog.model';
import { OzgcloudDialogService } from '../ozgcloud-dialog.service';

@Component({
  selector: 'odc-open-dialog-button',
  imports: [ButtonComponent],
  template: `
    <ods-button
      (clicked)="onClick()"
      [variant]="variant"
      [destructive]="destructive"
      [text]="label"
      [size]="size"
      [dataTestId]="dataTestId"
      [dataTestClass]="dataTestClass"
      data-test-id="open-dialog"
    >
      <ng-content icon select="[icon]" />
    </ods-button>
  `,
})
export class OpenDialogButtonComponent {
  private readonly component: ComponentType<any> = inject(DIALOG_COMPONENT);
  private readonly dialogService = inject(OzgcloudDialogService);
  readonly viewContainerRef = inject(ViewContainerRef);

  @Input() label: string;
  @Input() dataTestId: string;
  @Input() dataTestClass: string;
  @Input() dialogData: any;
  @Input() variant: ButtonVariants['variant'] = 'primary';
  @Input() size: ButtonVariants['size'];
  @Input({ transform: booleanAttribute }) destructive: boolean = false;

  @Output() dialogClose: EventEmitter<any> = new EventEmitter();
  public readonly clicked: OutputEmitterRef<void> = output<void>();

  public open(): void {
    this.dialogService
      .openInContext(this.component, this.viewContainerRef, this.dialogData)
      .closed.subscribe((closeResult: any) => this.dialogClose.emit(closeResult));
  }

  public onClick(): void {
    this.clicked.emit();
    this.open();
  }
}
